
/// <amd-module name="Search/Shared/Components/SearchOverlay/SearchOverlay.Props" />
import * as Spinner from "VSSUI/Spinner";

export interface ISearchOverlayProps {
    /**
    * Optional class name added to the Overlay component.
    */
    className?: string;

    /**
    * Optional spinner size. Default - Large.
    */
    spinnerSize?: Spinner.SpinnerSize;

    /**
    * Optional spinner text. Default - "Loading..."
    */
    spinnerText?: string;
}
